module.exports = __webpack_public_path__ + "img/OurPeople.170feb66.png";